const runtimeOrigin = (typeof window !== 'undefined' && window.location && window.location.origin)
  ? window.location.origin
  : 'http://localhost:5000';

const config = {
  // Backend API URL
  backendUrl: process.env.REACT_APP_API_URL || runtimeOrigin,
  
  // Uploads URL (same origin by default)
  uploadsUrl: process.env.REACT_APP_UPLOADS_URL || runtimeOrigin,
  
  // API endpoints
  apiEndpoints: {
    auth: '/api/auth',
    users: '/api/users',
    // New separate definition endpoints
    stockTypeDefinitions: '/api/stock-type-definitions',
    unitTypeDefinitions: '/api/unit-type-definitions',
    currencyDefinitions: '/api/currency-definitions',
    currentTypeDefinitions: '/api/current-type-definitions',
    warehouseDefinitions: '/api/warehouse-definitions',
    // Active records for stock movements
    activeCurrencies: '/api/currency-definitions/active',
    activeWarehouses: '/api/warehouse-definitions/active',
    defaultWarehouse: '/api/warehouse-definitions/default',
    activeCurrentAccounts: '/api/current-accounts/active',
    activeStockCards: '/api/stock-cards/active',

    company: '/api/company',
    products: '/api/products',
    inventory: '/api/inventory',
    orders: '/api/orders',
    stockMovements: '/api/stock-movements',
    movementTypes: '/api/movement-types',
    stockCards: '/api/stock-cards',
    currentAccounts: '/api/current-accounts',
    // Eksik endpoint'ler
    stockTypes: '/api/stock-type-definitions',
    units: '/api/unit-type-definitions',
    // Stok envanter endpoint'leri
    stockInventory: '/api/inventory/stock-inventory',
    warehouses: '/api/inventory/warehouses',
    
      // Üretim takip sistemi endpoint'leri
      talimat: '/api/talimat',
      costTracking: '/api/cost-tracking',
      supplierProfiles: '/api/supplier-profiles',
      colorDefinitions: '/api/color-definitions',
      processDefinitions: '/api/process-definitions',
      emanetStocks: '/api/emanet-stock',
    supplierTracking: '/api/supplier-tracking',
    supplierDefinitions: '/api/supplier-definitions',
    fabricRecipes: '/api/fabric-recipes',
    ormeMakineParkuru: '/api/orme/makine-parkuru',
    emanetInstructions: '/api/emanet-instructions',
    baskiNumuneler: '/api/baski/numuneler',
    
    // Sales Reports endpoints
    salesReports: {
      detailed: '/api/sales-reports/detailed',
      overview: '/api/sales-reports/overview',
      monthlyOverviewBulk: '/api/sales-reports/monthly-overview-bulk',
      byStock: '/api/sales-reports/by-stock',
      byCustomer: '/api/sales-reports/by-customer',
      byCustomerStock: '/api/sales-reports/by-customer-stock',
      byStockCustomer: '/api/sales-reports/by-stock-customer',
      customerHistorical: '/api/sales-reports/customer-historical',
      firstSales: '/api/sales-reports/first-sales'
    },
    
    // Profit Reports endpoints
    profitReports: {
      detailed: '/api/profit-reports/detailed',
      byStock: '/api/profit-reports/by-stock',
      byCustomer: '/api/profit-reports/by-customer'
    },
    
    // Reports endpoints
    idleStocks: '/api/reports/idle-stocks',
    
    // Medianteg Integration endpoints
    medianteg: {
      credentials: '/api/medianteg/credentials',
      token: '/api/medianteg/token',
      refreshToken: '/api/medianteg/token/refresh',
      test: '/api/medianteg/test',
      users: '/api/medianteg/users',
      fetchUsers: '/api/medianteg/users/fetch',
      mapUser: '/api/medianteg/users/map',
      unmapUser: '/api/medianteg/users/unmap',
      fetchApprovedCounts: '/api/medianteg/report/approved-counts',
      fabrics: '/api/medianteg/fabrics',
      fetchFabrics: '/api/medianteg/fabrics/fetch',
      mapFabric: '/api/medianteg/fabrics/map',
      unmapFabric: '/api/medianteg/fabrics/unmap',
      testProductRate: '/api/medianteg/product-rate/test',
      fabricScores: '/api/medianteg/fabric-scores',
      fabricAiBatch: '/api/medianteg/fabric-ai/batch',
      fabricAiEnsureSummary: '/api/medianteg/fabric-ai/ensure-summary',
      fabricAiStatus: '/api/medianteg/fabric-ai/status',
      fabricAiFeedback: '/api/medianteg/fabric-ai/feedback',
      fabricAiTrainingStats: '/api/medianteg/fabric-ai/training-stats',
      stockCardScore: '/api/medianteg/stock-card-score',
      bulkStockCardScores: '/api/medianteg/stock-card-scores/bulk',
      customerOrders: '/api/medianteg/customer-orders',
      orderDetailWeb: '/api/medianteg/order-detail-web'
    },
    
    // Customer Pre Orders endpoints
    customerPreOrders: '/api/customer-pre-orders',
    // Customer Visits endpoints
    customerVisits: '/api/customer-visits',
    // Customer Orders endpoints (admin panel)
    customerOrders: '/api/customer-orders',
    adminCustomerOrders: '/api/admin/customer-orders'
  }
};

export default config;
